export const options = [
  'Banket',
  'Beitbridge',
  'Bikita',
  'Bindura',
  'Bulawayo',
  'Chegutu',
  'Chinhoyi',
  'Chipinge',
  'Chitungwiza',
  'Dema',
  'Epworth',
  'Filabusi',
  'Guruve',
  'Gwanda',
  'Gweru',
  'Harare',
  'Hwange',
  'Kadoma',
  'Kariba',
  'Karoi',
  'Kwekwe',
  'Lupane',
  'Marondera',
  'Masvingo',
  'Mt. Darwin',
  'Murehwa',
  'Mvuma',
  'Nkayi',
  'Norton',
  'Nyanga',
  'Plumtree',
  'Redcliff',
  'Rusape',
  'Ruwa',
  'Shamva',
  'Shurugwi',
  'Umzingwane',
  'Victoria Falls',
  'Zvishavane',
];
